import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TrackTemplateEditToolbar from 'controls/track-template-edit-toolbar/TrackTemplateEditToolbar';
import Params from 'components/track-template-update/params/Params';

import Menu from 'controls/menu/Menu';
import ContentLoader from 'controls/content-loader/ContentLoader';

import request from 'actions/request';
import transmit from 'actions/transmit';

class TrackTemplateUpdate extends Component {
  componentDidMount() {
    if ((this.props.passedTemplateId !== this.props.storedTemplateId)) {
      this.props.request(
        ['trackTemplate', 'get'],
        'get',
        'TRACK_TEMPLATE',
        {
          trackId: this.props.trackId,
          templateId: this.props.passedTemplateId
        }
      ).then((payload) => {
        if (payload && payload.params && payload.params.length) {
          this.setChosenParams(payload.params);
        } else {
          this.setChosenParams([]);
        }
      })
    } else {
      this.setChosenParams(this.props.templateParams);
    }
  }

  setChosenParams(list) {
    let templateAnalogParams = list
      .filter((item) => (item.type === 'ap'))
      .map((item) => { return { id: item.id, type: item.type }});

    let templateBinaryParams = list
      .filter((item) => (item.type === 'bp'))
      .map((item) => { return { id: item.id, type: item.type }});

    this.props.transmit('SET_CHECKED_TRACK_PARAMS', {
      ap: templateAnalogParams,
      bp: templateBinaryParams
    });
  }

  buildBody() {
    if ((this.props.passedTemplateId !== this.props.storedTemplateId)) {
      return <ContentLoader/>;
    } else {
      return (<span>
        <TrackTemplateEditToolbar
          trackId={ this.props.trackId }
          templateId={ this.props.passedTemplateId }
          templateName={ this.props.templateName }
        />
        <Params
          trackId={ this.props.trackId }
          colorPickerEnabled={ false }
        />
      </span>);
    }
  }

  render () {
    return (
      <div>
        <Menu/>
        { this.buildBody() }
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    templatePending: state.trackTemplate.pending,
    trackId: ownProps.match.params.trackId,
    passedTemplateId: ownProps.match.params.templateId,
    storedTemplateId: state.trackTemplate.id,
    templateName: state.trackTemplate.name,
    templateParams: state.trackTemplate.params
  };
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch),
    transmit: bindActionCreators(transmit, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TrackTemplateUpdate);
